export default __webpack_public_path__ + "static/media/databricks.ad0cf1c3.svg";